import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { of, switchMap } from 'rxjs';
import { MetaData } from '../../../models/dashboard.model';
import { CommonService } from '../../../core/services/common.service';

@Component({
    selector: 'app-dashboard-metadata',
    templateUrl: './dashboard-metadata.component.html',
    styleUrl: './dashboard-metadata.component.css',
    standalone: false
})
export class DashboardMetadataComponent implements OnInit {
  metaData: MetaData[] = [];
  paginationMetaData: MetaData[] = [];
  moreToDisplay = true;

  constructor(
    private route: ActivatedRoute,
    private dataService: CommonService
  ) {}
  ngOnInit(): void {
    this.route.queryParamMap
      .pipe(
        switchMap((params) => {
          const id = params.get('reportId');
          return id != null
            ? this.dataService.getDashboardMetaData(id)
            : of(null);
        })
      )
      .subscribe((data) => {
        if (data != null) {
          this.metaData = data;
          this.paginationMetaData = this.metaData.slice(0, 5);
          this.moreToDisplay = this.metaData.length > 5;
        }
      });
  }

  showMore() {
    this.paginationMetaData = this.metaData;
    this.moreToDisplay = false;
  }

  showLess() {
    this.paginationMetaData = this.metaData.slice(0, 5);
    this.moreToDisplay = true;
  }

  displayValue(value: string) {
    console.log('value', value);
  }
}
